<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 16px; margin-bottom: 0px"
          >
            房源管理
          </div>
        </a-space>
        <a-button
          type="primary"
          style="float: right"
          @click="createHouseResource()"
          >构建房源</a-button
        >
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="提交时间">
            <a-range-picker
              v-model="queryParam.submitTime"
              style="width: 250px"
              :placeholder="['开始日期', '结束日期']"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              @change="onSearch"
            />
          </a-form-item>

          <a-form-item label="房源编号">
            <a-input-search
              placeholder="房源编号"
              v-model="queryParam.housingResId"
              style="width: 220px"
              @search="onSearch"
            />
          </a-form-item>

          <a-form-item label="房源名称">
            <a-input-search
              placeholder="房源名称"
              v-model="queryParam.housingResName"
              style="width: 220px"
              @search="onSearch"
            />
          </a-form-item>

          <br />
          <div style="margin-top: 4px">
            <a-form-item label="详细地址">
              <a-input-search
                placeholder="详细地址"
                v-model="queryParam.housingResAddress"
                style="width: 250px"
                @search="onSearch"
              />
            </a-form-item>

            <a-form-item label="权利人名称">
              <a-input-search
                placeholder="权利人名称"
                v-model="queryParam.obligeeName"
                style="width: 250px"
                @search="onSearch"
              />
            </a-form-item>

            <a-button type="primary" style="margin-top: 4px" @click="reset"
              >重置</a-button
            >
          </div>
        </a-form>
      </div>

      <a-table
        :pagination="table.pagination"
        :loading="table.loading"
        :columns="table.columns"
        :data-source="table.data"
        rowKey="webId"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      >
        <span slot="index" slot-scope="text, record, index">
          {{
            (table.pagination.pageNo - 1) * table.pagination.pageSize +
            index +
            1
          }}
        </span>

        <template slot="housingCover" slot-scope="text, record">
          <div class="cover-cell">
            <img
              v-if="record.housingCover"
              :src="record.housingCover"
              alt="房源封面"
              class="cover-img"
            />
            <span v-else class="cover-empty">暂无封面</span>
          </div>
        </template>

        <template slot="leaseUseType" slot-scope="text, record">
          <span>{{ formatLeaseUseType(record.leaseUseType) }}</span>
        </template>

        <template slot="operation" slot-scope="text, record">
          <a
            @click="changeToDetail({ ...record, isEditable: true })"
            style="color: #1890ff"
            >编辑</a
          >
          <a-divider type="vertical" />
          <a
            @click="changeToDetail({ ...record, isEditable: false })"
            style="color: #1890ff"
            >查看</a
          >
          <a-divider type="vertical" />
          <a @click="deleteResource(record)" style="color: #1890ff">删除</a>
        </template>
      </a-table>
    </a-card>

    <a-modal
      :width="1600"
      :footer="null"
      :visible="rightVisible"
      :closable="true"
      :destroyOnClose="true"
      :maskClosable="false"
      @cancel="closeMoudle"
      :zIndex="999"
    >
      <RightModal
        @closeMoudle="closeMoudle"
        @listSelectRight="listSelectRight"
      ></RightModal>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "封面",
    dataIndex: "housingCover",
    width: 100,
    scopedSlots: { customRender: "housingCover" },
  },
  { title: "房源名称", dataIndex: "housingResName", width: 250 },
  { title: "房源编号", dataIndex: "webId", width: 150 },
  {
    title: "租赁用途",
    dataIndex: "leaseUseType",
    width: 120,
    scopedSlots: { customRender: "leaseUseType" },
  },
  { title: "详细地址", dataIndex: "housingResAddress", width: 250 },
  {
    title: "最后编辑时间",
    dataIndex: "finalEditTime",
    width: 160,
    key: "finalEditTime",
  },
  {
    title: "操作",
    fixed: "right",
    width: 180,
    scopedSlots: { customRender: "operation" },
  },
];
const leaseUseTypeDictionaries = [
  {
    value: "1",
    note: "商业",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "2",
    note: "楼宇办公",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "8",
    note: "园区",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "16",
    note: "仓储",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "32",
    note: "厂房",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "64",
    note: "酒店",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "256",
    note: "住宅",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "512",
    note: "公寓",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "1024",
    note: "工业",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "2048",
    note: "农用",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "4096",
    note: "市政配套",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "8192",
    note: "场地",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "16384",
    note: "其他",
    classify: "ZLPT_ZLYT",
  },
];
import { listResource, deleteResource } from "@/api/property/Property.js";
import RightModal from "./RightModal";
import { scrollToTop } from "@/utils/util";
export default {
  components: {
    RightModal,
  },
  props: {
    toLedgerData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      //输入框
      queryParam: {
        submitTime: undefined,
        housingResId: undefined,
        housingResName: undefined,
        housingResAddress: undefined,
        obligeeName: undefined,
      },
      table: {
        data: [],
        loading: false,
        pagination: {
          showTotal: (total) => `共 ${total} 条`,
        },
        columns,
      },
      //权证对话框
      rightVisible: false,
    };
  },

  mounted() {
    this.queryParam.submitTime = this.toLedgerData.querySubmitTime;
    this.queryParam.housingResId = this.toLedgerData.queryHousingResId;
    this.queryParam.housingResName = this.toLedgerData.queryHousingResName;
    this.queryParam.housingResAddress =
      this.toLedgerData.queryHousingResAddress;
    this.queryParam.obligeeName = this.toLedgerData.queryObligeeName;
    this.table.pagination.current = this.toLedgerData.page;
    this.getTableDetails({
      pageSize: this.toLedgerData.pageSize,
      page: this.toLedgerData.page,
      submitTime: this.queryParam.submitTime,
      housingResId: this.queryParam.housingResId,
      housingResName: this.queryParam.housingResName,
      housingResAddress: this.queryParam.housingResAddress,
      obligeeName: this.queryParam.obligeeName,
    });
  },

  methods: {
    /**
     * 分页,查询
     * 根据条件筛选并重置分页,可复制
     */
    onSearch() {
      const pager = { ...this.table.pagination };
      pager.current = 1;
      this.handleTableChange(pager);
    },

    /**
     * 分页,点击下一页
     * 表格变化回调，用于分页,筛选和排序,可复制 参数略有修改
     */
    handleTableChange(pagination) {
      //设置重置按钮分页回到第一页
      const pager = { ...this.table.pagination };
      pager.current = pagination.current;
      this.table.pagination = pager;
      this.getTableDetails({
        pageSize: pagination.pageSize,
        page: pagination.current,
        submitTime: this.queryParam.submitTime,
        housingResId: this.queryParam.housingResId,
        housingResName: this.queryParam.housingResName,
        housingResAddress: this.queryParam.housingResAddress,
        obligeeName: this.queryParam.obligeeName,
      });
    },

    /**
     * 分页,默认第一页+查询
     * 获取选择层级下角色列表
     */
    getTableDetails(params = {}) {
      this.table.loading = true;
      listResource({
        page: 1,
        pageSize: 10,
        ...params,
      }).then((res) => {
        const pagination = { ...this.table.pagination };
        pagination.total = res.total;
        pagination.pageSize = res.pageSize;
        pagination.pageNo = res.pageNo;
        pagination.current = res.pageNo;
        if (res.pageNo != 1 && res.data.length == 0) {
          //用于新增或删除后自动刷新，避免页面为空现象
          this.getTableDetails({
            pageSize: res.pageSize,
            page: res.pageNo - 1,
            submitTime: this.queryParam.submitTime,
            housingResId: this.queryParam.housingResId,
            housingResName: this.queryParam.housingResName,
            housingResAddress: this.queryParam.housingResAddress,
            obligeeName: this.queryParam.obligeeName,
          });
        }
        if (res.pageNo == 1 || res.data.length != 0) {
          this.table.data = res.data;
          this.table.loading = false;
          this.table.pagination = pagination;
        }
      });
    },

    //重置表格查询
    reset() {
      //重置
      this.queryParam.submitTime = undefined;
      this.queryParam.housingResId = undefined;
      this.queryParam.housingResName = undefined;
      this.queryParam.housingResAddress = undefined;
      this.queryParam.obligeeName = undefined;
      this.onSearch();
    },

    /**
     * 刷新当前页(用于新增或删除后自动刷新)
     */
    refreshCurrentPage() {
      const pager = { ...this.table.pagination };
      if (pager.current == undefined || pager.current == 1) {
        this.onSearch();
      } else {
        this.handleTableChange(pager);
      }
    },

    changeToDetail(val) {
      this.$emit("changeToDetail", {
        webId: val.webId,
        isEditable: val.isEditable,
        //选择权证列表
        selectRightList: val.selectRightList,
        //当前页面查询信息
        page: this.table.pagination.pageNo,
        pageSize: this.table.pagination.pageSize,
        querySubmitTime: this.queryParam.submitTime,
        queryHousingResId: this.queryParam.housingResId,
        queryHousingResName: this.queryParam.housingResName,
        queryHousingResAddress: this.queryParam.housingResAddress,
        queryObligeeName: this.queryParam.obligeeName,
      });
      //滚动到最顶端
      scrollToTop(this)
    },

    closeMoudle() {
      this.rightVisible = false;
    },

    listSelectRight(val) {
      this.$emit("changeToDetail", {
        webId: undefined,
        isEditable: true,
        //构建房源标志位
        selectRightList: val.selectRightList,
        //当前页面查询信息
        page: this.table.pagination.pageNo,
        pageSize: this.table.pagination.pageSize,
        querySubmitTime: this.queryParam.submitTime,
        queryHousingResId: this.queryParam.housingResId,
        queryHousingResName: this.queryParam.housingResName,
        queryHousingResAddress: this.queryParam.housingResAddress,
        queryObligeeName: this.queryParam.obligeeName,
      });
      this.rightVisible = false;
      //滚动到最顶端
      scrollToTop(this)
    },

    createHouseResource() {
      this.rightVisible = true;
    },

    deleteResource(record) {
      var _that = this;
      this.$confirm({
        title: "删除房源",
        content: "请确定是否删除房源，谨慎操作！",
        onOk() {
          deleteResource({
            webId: record.webId,
          })
            .then((res) => {
              if (res.code === "200") {
                _that.$notification.success({
                  message: "删除房源",
                  description: `成功`,
                });
                _that.refreshCurrentPage();
              } else {
                _that.$notification["error"]({
                  message: "错误",
                  description: res.msg,
                });
              }
            })
            .catch((err) => {
              _that.$notification["error"]({
                message: "错误",
                description:
                  ((err.response || {}).data || {}).message ||
                  "网络异常，请稍后再试",
                duration: 4,
              });
            });
        },
        onCancel() {},
      });
    },

    //租赁用途转换
    formatLeaseUseType(value) {
      if (!value) return "-";

      let valueList = [];

      if (Array.isArray(value)) {
        valueList = value;
      } else if (typeof value === "string") {
        try {
          valueList = JSON.parse(value);
        } catch (e) {
          valueList = [value];
        }
      }

      if (!Array.isArray(valueList) || valueList.length === 0) {
        return "-";
      }

      const dictMap = leaseUseTypeDictionaries;

      return valueList
        .map((item) => {
          const match = dictMap.find(
            (dict) => String(dict.value) === String(item)
          );
          return match ? match.note : item;
        })
        .join(";");
    },
  },
};
</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}

.cover-cell {
  width: 70px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
  background: #f5f5f5;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cover-empty {
  font-size: 12px;
  color: #999;
}
</style>